import cookies from 'js-cookie';

const getHostEntity = () => {
  let hostUrl = `//gateway.dandythrust.com/graphql`;
  let imageUrl = '//image.dandythrust.com';
  let udeskAuthen =
    'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmaXJzdF9uYW1lIjoiIiwibGFzdF9uYW1lIjoiIiwiZW1haWwiOiJ1ZGVzay5pbnRlcmdyYXRpb25Ac3R1ZGVudC5jb20iLCJ1dWlkIjoiNmNhOTkyOGQtNmY2NS00ODI2LWI5NjMtMDUzMmZiMWFkODdkIiwicm9sZV9kYXRhIjpudWxsLCJyb2xlcyI6WyJzdHVkZW50Il0sImlhdCI6MTU0NzcxNjgwNSwiaXNzIjoiYXV0aCJ9.UuLz098oc4mKFjfOOU-XRXqLS4-e6xy1mIWPF62wygY';
  let propertyUrl = 'https://hurricane-www.dandythrust.com/';
  let udeskAuthKey = '33ebe5b6e14329fb3fa4d80fb30fae58';
  let salesforceDomain = 'https://student--dev.lightning.force.com';
  let facadeUrl = '//cms-facade-uat1.dandythrust.com';
  let agentUrl = window.location.origin + '/cms/agent/#';
  let cdnUrl = 'https://storm-frontend-cdn.dandythrust.com';

  let hostName = process.env.HOST_NAME;

  //@building-removing start
  let hostNameFromCookie = cookies.get(process.env.PUBLIC_URL?.slice(5)); //remove /cms/
  if (
    process.env.HOST_NAME !== 'prod' &&
    hostNameFromCookie &&
    !location?.hostname?.includes('localhost')
  ) {
    hostName = hostNameFromCookie;
  }

  //@building-removing end
  switch (hostName) {
    case 'uat1':
    case 'uat2':
    case 'uat3':
      hostUrl = `https://gateway-${hostName}.dandythrust.com/graphql`;
      facadeUrl = `https://cms-facade-${hostName}.dandythrust.com`;
      propertyUrl = `https://${hostName}-www.dandythrust.com/`;
      break;
    case 'stage':
      hostUrl = `https://gateway.dandythrust.com/graphql`;
      facadeUrl = `//cms-facade.dandythrust.com`;
      break;
    case 'prod':
      propertyUrl = 'https://www.student.com/';
      hostUrl = '//gateway.student.com/graphql';
      imageUrl = '//image.student.com';
      udeskAuthKey = '9405630abdf9c1d3f4b37d3dd24c4bfd';
      salesforceDomain = 'https://student.lightning.force.com';
      facadeUrl = `//cms-facade.student.com`;
      cdnUrl = 'https://cdn.student.com';

      udeskAuthen =
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaXJzdF9uYW1lIjoiIiwibGFzdF9uYW1lIjoiIiwiZW1haWwiOiJpbnRlZ3JhdGlvbi51ZGVza0BzdHVkZW50LmNvbSIsInV1aWQiOiI4NDAwMzRiMS0wZmY5LTQyYmMtYjJlZC1jYTI4ZWFiZjQwMDMiLCJyb2xlX2RhdGEiOm51bGwsInNjb3BlcyI6eyJyZWFkOmJvb2tpbmdzIjp7fSwicmVhZDpwcm9wZXJ0aWVzIjp7fSwicmVhZDpsaXN0aW5ncyI6e319LCJyb2xlcyI6WyJpbnRlZ3JhdGlvbiJdLCJpYXQiOjE1NDkwOTI1NzcsImlzcyI6ImF1dGgifQ.vz2Gh5dFB7UXcs_aOKHROvu9HAFQy4AwLdbneVwuOEw';
      break;
    default:
      break;
  }

  return {
    imageUrl,
    hostUrl,
    udeskAuthen,
    propertyUrl,
    udeskAuthKey,
    salesforceDomain,
    facadeUrl,
    prefix: `${hostName}_`,
    authImageUrl: propertyUrl,
    agentUrl,
    cdnUrl,
  };
};

export const Hosts = getHostEntity();
